// tslint:disable: max-line-length
import { DateFormatEnum, formatDate } from '../../helpers/dates';
import moment from 'moment';
export enum DateTimeFormat {
  'date' = 'date',
  'dateTime' = 'dateTime',
  'dateOnlyRange' = 'dateOnlyRange',
}
export const fetchRangeDate = (form) => {
  if (form.fromDate2 && form.toDate2) {
    return (
      getDateRange(form.fromDate, form.toDate) +
      ' & ' +
      getDateRange(form.fromDate2, form.toDate2)
    );
  }
  if (
    moment(form.fromDate).utc().format('DD MM YYYY') ===
    moment(form.toDate).utc().format('DD MM YYYY')
  ) {
    return formatDate(String(form.fromDate), DateFormatEnum.dateFormat);
  }
  return form.fromDate && form.toDate
    ? formatDate(moment(form.fromDate).utc().toString(), DateFormatEnum.date) +
        ` - ${formatDate(moment(form.toDate).utc().toString(), DateFormatEnum.date)}`
    : '-';
};
const getDateTimeData = (categoryData) => {
  let dateTimeStamp;
  if (categoryData.dateTimeFormat === DateTimeFormat.date) {
    dateTimeStamp = categoryData.date
      ? formatDate(categoryData.date.toString(), DateFormatEnum.dateFormat)
      : '';
  }
  if (categoryData.dateTimeFormat === DateTimeFormat.dateTime) {
    const isTimeNotSet =
      '00:00' ===
      (categoryData.dateTime
        ? formatDate(
            categoryData.dateTime.toString(),
            DateFormatEnum.time
          ).toString()
        : '');
    dateTimeStamp = categoryData.dateTime
      ? formatDate(
          categoryData.dateTime.toString(),
          isTimeNotSet ? DateFormatEnum.dateFormat : DateFormatEnum.charDateTime
        )
      : '';
  }
  if (categoryData.dateTimeFormat === DateTimeFormat.dateOnlyRange) {
    dateTimeStamp =
      categoryData.fromDate && categoryData.toDate
        ? fetchRangeDate(categoryData)
        : '';
  }
  return dateTimeStamp;
};

const getDateRange = (sDate, eDate) => {
  if (
    moment(sDate).utc().format('DD MM YYYY') ===
    moment(eDate).utc().format('DD MM YYYY')
  ) {
    return formatDate(String(sDate), DateFormatEnum.dateFormat);
  }
  if (eDate) {
    const monthEnd = moment(eDate).format('MMMM');
    const monthStart = moment(sDate).format('MMMM');

    if (monthEnd === monthStart) {
      const endDay = formatDate(String(eDate), DateFormatEnum.dateFormat);
      const startDay = moment(sDate).utc().format('DD');
      return `${startDay} - ${endDay}`;
    } else {
      const endDay = formatDate(String(eDate), DateFormatEnum.dateFormat);
      const startDay = moment(sDate).utc().format('DD MMMM');
      return `${startDay} - ${endDay}`;
    }
  }
  return (
    moment(sDate).utc().format(DateFormatEnum.date) +
    `${eDate ? ' - ' + moment(eDate).format(DateFormatEnum.date) : ''}`
  );
};
export const getDepartmentText = (categoryData) => {
  let dateTimeStamp;
  if (categoryData && categoryData.isDateTimeRequired) {
    dateTimeStamp = getDateTimeData(categoryData);
  }
  return `${categoryData && dateTimeStamp !== undefined && dateTimeStamp !== null && dateTimeStamp !== '' ? dateTimeStamp : ''}`;
};
